const wrapSearchWithProductContext = (searchTerm, pageContext) => {
  if ((pageContext == null ? void 0 : pageContext.pageType) !== "pdp" || !(pageContext == null ? void 0 : pageContext.stacklineSku)) {
    return searchTerm;
  }
  if (searchTerm.includes("<product")) {
    return searchTerm;
  }
  return `<product featured="true" stacklineSku="${pageContext.stacklineSku}" question="${searchTerm}" />`;
};
export {
  wrapSearchWithProductContext
};
//# sourceMappingURL=wrapSearchWithProductContext.js.map
